export class BackendEvent<T> extends Event {
  payload: T;

  constructor(type: string, payload: T) {
    super(type);
    this.payload = payload;
  }
}
